import classNames from 'classnames';

import { StoryTileSkeleton } from './StoryTileSkeleton';

const ONE_ROW_VISIBILITY = [
  '',
  '',
  'hidden md:block',
  'hidden lg:block portrait-lg:!hidden',
];

interface IProps {
  count?: number;
}
export const StoryTileSkeletonGrid = ({ count }: IProps) => {
  const tileCount = count ?? ONE_ROW_VISIBILITY.length;

  return (
    <>
      <div className="mx-auto w-full max-w-[1400px] px-3 p-4 sm:px-6">
        <div className="h-6 w-32 animate-pulse rounded bg-black/10 dark:bg-white/10" />
      </div>

      <div className="grid w-full grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 portrait-lg:!grid-cols-3">

        {Array.from({ length: tileCount }, (_, index) => (
          <StoryTileSkeleton
            key={index}
            className={
              count === undefined
                ? classNames(ONE_ROW_VISIBILITY[index])
                : undefined
            }
          />
        ))}
      </div></>
  );
};
